import React from 'react';
import NextArrow from '../../../assets/images/SliderNextArrow';
import PreviousArrow from '../../../assets/images/SliderPrevArrow';

interface ExpertiseNavigationProps {
  onPrev: () => void;
  onNext: () => void;
  isFirst: boolean;
  isLast: boolean;
}

const ExpertiseNavigation: React.FC<ExpertiseNavigationProps> = ({
  onPrev,
  onNext,
  isFirst,
  isLast,
}) => (
  <div className="expertise-navigation"
    data-aos="fade-up"
    data-aos-duration="1500">
    <button onClick={onPrev} className="expertise-nav-btn" disabled={isFirst}>
      <PreviousArrow />
    </button>
    <button onClick={onNext} className="expertise-nav-btn" disabled={isLast}>
      <NextArrow />
    </button>
  </div>
);

export default ExpertiseNavigation;
